import "./App.css";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "./context/ThemeContext";
import useSessionValidation from "./hooks/useSessionValidation";
import Topbar from "./components/Topbar/Topbar";
import Footer from "./components/Footer/Footer";
import AppRoutes from "./routes/AppRoutes";

function App() {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  // Hook para validar la sesión y renovar
  useSessionValidation(
    user,
    dispatch,
    navigate,
    lastClickTime,
    setLastClickTime
  );

  const handleClick = useCallback(() => {
    const currentTimeT = Date.now();
    const timeDifference = currentTimeT - lastClickTime;
    if (timeDifference > 50000) {
      setLastClickTime(currentTimeT);
    }
  }, [lastClickTime]);

  useEffect(() => {
    const handleKeyOrClick = (event) => {
      if (
        event.type === "click" ||
        event.key === "Tab" ||
        event.key === "Enter" ||
        (event.key >= "0" && event.key <= "9") ||
        event?.code?.includes("Numpad")
      ) {
        handleClick();
      }
    };

    document.addEventListener("click", handleKeyOrClick);
    document.addEventListener("keydown", handleKeyOrClick);
    return () => {
      document.removeEventListener("click", handleKeyOrClick);
      document.removeEventListener("keydown", handleKeyOrClick);
    };
  }, [handleClick]);

  return (
    <div className={`container-app app-${theme}`}>
      <Topbar toggleTheme={toggleTheme} theme={theme} />
      <AppRoutes />
      <Footer />
    </div>
  );
}

export default App;
